
















































































import BillingProviderProduct from '@/datatypes/billing/provider-product';
import BillingProductService from '@/services/billing/BillingProductService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    billingProducts: new Array<BillingProviderProduct>(),
    hasNext: true,
    errorMessage: '',
    billingProductSearch: { term: '' as string | (string | null)[] },
    nextPointer: undefined as string | undefined,
    billingProductService: new BillingProductService(),
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      if (this.$route.query.term) {
        this.billingProductSearch.term = this.$route.query.term;
      }

      this.getProviderBillingProviderProducts();
    },

    getListOptions() {
      return {
        term: this.billingProductSearch.term,
        next: undefined,
      };
    },

    searchProducts() {
      if (this.billingProductSearch.term.length === 0) {
        this.billingProducts = new Array<BillingProviderProduct>();
        this.$route.query.next = '';

        return this.getProviderBillingProviderProducts();
      }

      return this.billingProductService.searchProvider(this.getListOptions()).then((response) => {
        this.hasNext = false;
        this.billingProducts = response.data.map(
          (data) => new BillingProviderProduct(camelcaseKeysDeep(data)),
        );
      });
    },

    concatResponse(data: BillingProviderProduct[]) {
      this.billingProducts = this.billingProducts.concat(data);
    },

    getProviderBillingProviderProducts() {
      const nextPage = this.$route.query.next;

      this.billingProductService.listProvider(this.getListOptions()).then((response) => {
        this.concatResponse(response.data.map(
          (data) => new BillingProviderProduct(camelcaseKeysDeep(data)),
        ));
        if (!nextPage && this.billingProducts.length === 0) {
          this.errorMessage = 'No billing products found.';
        }
        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        } else {
          this.nextPointer = undefined;
          this.hasNext = false;
        }
        if (response.data.length === 0) {
          this.hasNext = false;
        }
      });
    },

    requestNextPage() {
      this.navigateUrl(this.nextPointer);
    },

    navigateUrl(next) {
      const query = this.getListOptions();
      query.next = next;

      this.$router.push({ query }).catch((err) => {
        if (err.name === 'NavigationDuplicated') {
          this.getProviderBillingProviderProducts();
        } else {
          throw err;
        }
      });
    },
  },
});
